export interface WebhookUrl{
    type: WEBHOOK_TYPES;
    url: string;
}

export enum WEBHOOK_TYPES {
    BALANCE_ALERT = "low-balance-alert",
    DATA_USAGE_THRESHOLD = "data-usage-threshold",
    ESIM_STATUS = "EsimStatus",
    CUSTOMER_REGISTRATION = "SdkActivation",
    COUNTRY_CHANGE = "CountryChange",
    BALANCE_ACTIVATION = "BalanceActivation"
}
